"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlQuery = void 0;
const urlQuery = (obj) => Object.entries(obj)
    // @ts-ignore
    .map((pair) => pair.map(encodeURIComponent).join('='))
    .join('&');
exports.urlQuery = urlQuery;
